export default "/images/4d1a274bc11bb8a5799724a7497e9768.avif";